module.exports = __webpack_public_path__ + "img/DarkCookies.054316f1.svg";